import React, { useState } from "react";
import { Flame } from "lucide-react";

export const EventImage = ({ src, alt = "", imgClassName = "" }) => {
  const [broken, setBroken] = useState(!src);

  if (broken) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center gap-2 bg-[#0B0C0E]" data-testid="event-image-fallback">
        <Flame className="w-9 h-9 text-amber-500" />
        <div className="font-serif text-sm tracking-wide text-amber-100">swiss-pagan<span className="text-amber-500">.ch</span></div>
      </div>
    );
  }

  return <img src={src} alt={alt} loading="lazy" onError={() => setBroken(true)} className={imgClassName} />;
};

export default EventImage;
